import { initRouter } from "./router.js";
import { initCart, addItem as addToCart } from "./cart.js";
import { initAnalytics } from "./analytics.js";
import { initEditor } from "./editor.js";
import { initUI } from "./ui.js";

(async function () {
  const cookies = document.cookie;
  // const searchParams = new URLSearchParams(window.location.search);

  const inPreviewMode = cookies.includes("preview=");

  const params = new URLSearchParams(window.location.search);

  // Receives Messages from Theme Tweaker
  if (inPreviewMode || params.has("preview")) {
    initEditor();
  } else {
    // Things not needed in preview
    initAnalytics();
  }

  await initRouter(addToCart);

  initCart();

  initUI();

  class MOSSY {
    constructor() {}
  }

  // Expose only what's necessary
  window.MOSSY = new MOSSY();
})();
